<button
    [routerLink]="[
        '/',
        'portal',
        'meine-vertraege',
        this.damageReport().contractId,
        'gemeldete-schaeden',
        this.damageReport().id,
    ]"
>
    <app-portal-widget-details
        heading="Erstellungsdatum"
        [detail]="this.damageReport().createdAt | date: 'dd.MM.yyyy'"
    ></app-portal-widget-details>

    <app-portal-widget-details
        heading="Stand"
        [detail]="this.damageReport().stateDescription"
        [icon]="this.damageReport().state === damageState.COMPLETED ? 'circle_check' : 'circle'"
        [iconClass]="iconColor() + ' fs:l'"
    ></app-portal-widget-details>
    <i
        ctrlIcon="chevron_right"
        class="c:blue-1"
    ></i>
</button>
